'use strict';

const textBoxTemplate = require('components/ui/field_text_box/templates/desktop/main.html');
const createTextBoxFieldFactory = require('components/ui/field_text_box/js/main_creator');
const TextBoxFieldView = require('components/ui/field_text_box/js/view');
const withProps = require('components-framework/view/with_props');

module.exports = createTextBoxFieldFactory({
    name: 'name_on_card_field',
    viewClass: withProps(TextBoxFieldView),
    modelClass: require('./model'),
    template: textBoxTemplate,
    fieldOptions: Odigeo.CreditCard.fields.nameOnCard,
});
